export const featurePageMapping: { [key: string]: PageMapping } = {
	"/benchmark": {
		actions: [],
		buttons: [],
		icon: "leaderboard",
		label: "Benchmark",
		labelKey: "nav.benchmark.module.label",
		nav: false,
		title: "Benchmark",
		titleKey: "nav.benchmark.module.title"
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping
};
